<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 list-paragraph" id="references-2">
<h1 class="list-paragraph">References</h1>
<p><strong>Aas, K (1972):</strong> Biochemical and Immunological Basis of Bronchial Asthma. American Lecture Series. CC Thomas, Springfield USA. ISBN 0-398-02213-54.</p>
<p><strong>Aas, K (2011):</strong> Miljøhemming. En skjult funksjonshemming. Kolofon Publisher, Oslo. ISBN 978-82-300-0835-5. <a href="http://www.inneklima.com/index.asp?context=99&amp;document=667" target="_blank">Environment-induced disability, an invisible handicap. (Summary in English).</a> Free Norwegian web version.</p>
<p><strong>Kopot, A</strong> <strong>(2014):</strong> AK lectures: <a href="http://www.aklectures.com/subject/organic-chemistry" target="_blank">Organic chemistry</a>.</p>
<p><strong>Kopot, A</strong> (<strong>2014):</strong> AK lectures: <a href="http://www.aklectures.com/subject/general-chemistry" target="_blank">General chemistry</a>.</p>
<p><strong>Pall ML (2007):</strong> Nitric oxide synthase partial uncoupling as a key switching mechanism for the NO/ONOO - cycle. Med Hypotheses; 69: 821 – 5. <a href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Nitric+oxide+synthase+partial+uncoupling+as+a+key+switching+mechanism+for+the+NO%2FONOO+-+cycle" target="_blank">Abstract</a>.</p>
<p><strong>Pall ML (2013):</strong> Electromagnetic fields act via activation of voltage-gated calcium channels to produce beneficial or adverse effects. J Cell Mol Med; 17: 958 – 65. <a href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC3780531/" target="_blank">Free article</a>.</p>
<p><strong>Rossi A</strong> <strong>(2014):</strong> The-ion-channel-through-the-keyhole. The naked scientist. University of Cambridge. <a href="http://www.thenakedscientists.com/HTML/articles/article/the-ion-channel-through-the-keyhole/" target="_blank">Free website article</a>, Sun, 19th Oct 2008.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?e6a32968